package org.example.project.manager

import kotlinx.serialization.Serializable

@Serializable
class SystemNodeWorkerInfo(
    val buildName: String = "",
    val preferred: Boolean = false,
    val healthy: Boolean = false,
    val activeSessions: Int = 0,
    val startzeit: String = "",
    val startzeitEpochMs: Long = 0,
    val laufzeit: String = ""
)

@Serializable
data class SystemNodeInfo(
    val id: String = "",
    val status: String = "",
    val typ: String = "",
    val environment: String = "",
    val port: String = "",
    val version: String = "",
    val startzeit: String = "",
    val dataPath: String = "",
    val logPath: String = "",
    val processId: String = "",
    val fehlerCounter: Int = 0,
    val steuerbar: Boolean = false,
    val firmenId: String = "",
    val firma: String = "",
    val laufzeit: String = "",
    val activeSessions: Int = 0,
    val workers: List<SystemNodeWorkerInfo> = emptyList(),
    val lizenz: String = "",
    val proxy: String = ""
)

@Serializable
class SystemNodeError(
    val id: String = "",
    val datum: String = "",
    val uhrzeit: String = "",
    val level: String = "",
    val nachricht: String = ""
)
